import * as types from './types'

const initialState = {
    list: [],
    condFilters: {},
    total: 0,
}
const account = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_LIST_ACCOUNT_MERCHANT:
        case types.GET_ACCOUNT_MERCHANT_SEARCH_FULLNAME:
        case types.GET_ACCOUNT_MERCHANT_SEARCH_USERNAME:
        case types.GET_ACCOUNT_MERCHANT_SEARCH_INTERVAL:
            return {
                ...state,
                ...action.payload,
                type: action.type,
                list: action.payload.isScroll
                    ? [...state.list, ...action.payload.list]
                    : action.payload.list
            }
        case types.RESET_LIST_ACCOUNT_MERCHANT:
            return initialState
        default:
            return state;
    }

}

export default account